export const dateRangeFilterFieldId = 'app-updates-recently-published-filter';

export const getEffectiveFrom = (): string => {
  const date = new Date();
  date.setDate(date.getDate() - 7);

  return date.toISOString();
};
